// extracted by mini-css-extract-plugin
export default {"requirementText":"kycDetailsPopUp_requirementText__qX6IP","slideTransition":"kycDetailsPopUp_slideTransition__4VhqA"};